import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["isField", "error", "popoverIcon"];
import * as React from 'react';
var InputText = function InputText(props) {
  var isField = props.isField,
    error = props.error,
    popoverIcon = props.popoverIcon,
    extraProps = _objectWithoutProperties(props, _excluded); // eslint-disable-line no-unused-vars
  // $FlowFixMe[cannot-spread-inexact]
  return /*#__PURE__*/React.createElement("input", _extends({
    type: "text",
    className: "form-control"
  }, extraProps));
};
export default InputText;